import { create } from 'zustand/react';
import { createJSONStorage, persist } from 'zustand/middleware';
import { BreadcrumbSlice, createBreadcrumbSlice } from 'hooks/state/BreadcrumbSlice';
import { searchParamsStorage } from 'hooks/state/UrlPersistence';
import { parseISO } from 'date-fns';
import { timeZoneSafeDateString } from 'utils/dateUtils';

export const useBreadcrumbStore = create<BreadcrumbSlice>()(
  persist((...a) => createBreadcrumbSlice(...a), {
    name: 'breadcrumbs',
    storage: createJSONStorage(() => searchParamsStorage, {
      replacer(key) {
        // @ts-expect-error as per docs
        const v = this[key] as unknown;

        if (v instanceof Date) {
          return { date_type: 'Date', value: timeZoneSafeDateString(v) };
        }

        return v;
      },
      reviver(_, value) {
        if ((value as { date_type?: string })?.date_type === 'Date') {
          // @ts-expect-error as per docs
          return parseISO(value.value as string);
        }

        return value;
      },
    }),
  })
);
